module.exports = __webpack_public_path__ + "Flag-520.21d9d1120ae5ed0aa2e453bb74f6782a.svg";